function stripHtml(html) {
  return html
    .replace(/<[^>]*>/g, '')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");
}

function transformItem(item, index) {
  const lprice = parseInt(item.lprice, 10) || 0;
  const hprice = parseInt(item.hprice, 10) || 0;
  const discountRate =
    hprice > lprice ? Math.round((1 - lprice / hprice) * 100) : 0;

  return {
    id: `naver-${item.productId || index}`,
    name: stripHtml(item.title),
    imageUrl: item.image,
    price: lprice,
    originalPrice: hprice || lprice,
    lowestPrice: lprice,
    discountRate,
    drop: discountRate > 0 ? -discountRate : 0,
    store: item.mallName,
    category: item.category1 || '기타',
    icon: '📦',
    history: [],
    watching: 0,
    link: item.link,
    brand: stripHtml(item.brand || ''),
    maker: stripHtml(item.maker || ''),
    isNaverResult: true,
  };
}

const HOT_QUERIES = ['인기 할인', '특가 행사', '타임세일 상품'];

export async function fetchHotDeals() {
  const query = HOT_QUERIES[Math.floor(Math.random() * HOT_QUERIES.length)];
  const items = await searchNaver(query, { display: 20, sort: 'sim' });
  return items
    .filter(item => item.originalPrice > item.price && item.discountRate >= 10)
    .sort((a, b) => b.discountRate - a.discountRate)
    .slice(0, 6);
}

export async function searchNaver(query, { display = 20, sort = 'sim' } = {}) {
  const params = new URLSearchParams({ query, display, sort });
  const res = await fetch(`/api/naver-search?${params.toString()}`);

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `API 오류 (${res.status})`);
  }

  const data = await res.json();
  return (data.items || []).map(transformItem);
}
